import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";
import { Icon, PlainButton, Tooltip } from "@culturehq/components";

import { Trans } from "app/utils";

import { CreatomateContext } from "../../contexts/VideoStudioContext";

interface DownloadButtonProps {
  isDownloading: boolean;
  onDownload: () => void;
  preview: Preview;
}

const DownloadBtn: React.FC<DownloadButtonProps> = ({ isDownloading, onDownload, preview }) => {
  const { ready, state } = preview;
  const elements = state?.elements || [];
  const { data } = useContext(CreatomateContext);
  const { loading, pendingSubtitle, uploadingMedia } = data;

  const isButtonDisabled = !!isDownloading || !!loading || !ready || uploadingMedia
    || !!pendingSubtitle || elements.length === 0;

  return (
    <PlainButton
      disabled={isButtonDisabled}
      className={`Download-Btn ${isButtonDisabled ? "Download-Btn_disabled" : ""}`}
      onClick={isDownloading ? () => {} : onDownload}
    >
      <Icon icon="download" />
      <Trans>Download</Trans>
    </PlainButton>
  );
};

const DownloadButton: React.FC<DownloadButtonProps> = ({
  isDownloading, onDownload, preview
}) => {
  const { data } = useContext(CreatomateContext);
  const { onMediaEdited, pendingSubtitle, uploadingMedia } = data;
  const tooltipData = () => {
    if (pendingSubtitle) return { display: true, message: "Please wait while the transcription is being processed" };
    if (uploadingMedia) return { display: true, message: "The video is being uploaded" };
    return { display: false, message: "" };
  };
  const tooltip = tooltipData();

  if (onMediaEdited) return <></>;

  return (
    <>
      {tooltip.display ? (
        <Tooltip
          tip={
            <p className="Tooltip-uploaded">
              {tooltip.message}
            </p> as unknown as string
          }
        >
          <DownloadBtn isDownloading={isDownloading} onDownload={onDownload} preview={preview} />
        </Tooltip>
      ) : (
        <DownloadBtn isDownloading={isDownloading} onDownload={onDownload} preview={preview} />
      )}
    </>
  );
};

export default DownloadButton;
